import { gql } from '@apollo/client';

const getSiteUsersForSite = gql`
  query GetSiteUsersForSite(
    $siteId: Int!
    $filter: SiteUserListingFilterType!
    $ascending: Boolean
    $searchTerm: String
    $sortfield: SortField
  ) {
    siteUsers {
      listSiteUsersForSite(
        siteId: $siteId
        filter: $filter
        ascending: $ascending
        searchTerm: $searchTerm
        sortfield: $sortfield
      ) {
        avatar
        companyName
        email
        telephone
        id
        lastLoggedIn
        name
        sufficentSubscriptionLevel
        siteId
        siteRoleId
        siteRoleName
        status
      }
    }
  }
`;

export default getSiteUsersForSite;
